
import Input from "../../../common/input/Input";

export default function FieldPrice({ price, onChange }) {
	return (
		<div className="relative [&_input]:pl-14">
			<Input onChange={onChange} value={price} label="قیمت کارگاه" inputMode="numeric" />
			<span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 font-Vazir-500 text-[13px] text-darkBlue/45">
				تومان
			</span>
		</div>
	);
}
